/* created by CoolGuy on 2018/12/9 */
import {observable,action} from 'mobx';

// 专门管理底部的，否则太乱了
export default class BottomCommentStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
    }
    @observable showMultiBottom = false;
    @action toggleMultiBottom = (flag)=>{
        this.showMultiBottom = typeof flag === 'boolean' ? flag : !this.showMultiBottom;
    }

}



// WEBPACK FOOTER //
// ./src/store/BottomCommentStore.js